import { useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Players } from 'design-system/AcSidebar/constants';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';
import { useTabTracking } from 'hooks/useTabTracking';

import PageTopBar from 'components/Topbar/PageTopBar';

export enum EPlayersState {
  BLOCKED = 'blocked'
}

export const PlayersView = () => {
  const { publisherId, portalId } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState<EPlayersState>(EPlayersState.BLOCKED);

  const basePath = publisherId ? `/project/${publisherId}` : `/portal/${portalId}`;

  const getPlayersPath = (basePath: string, state: EPlayersState) => `${basePath}/players/${state}`;

  const tabs = [{ label: 'Blocked players', value: EPlayersState.BLOCKED }];

  const { handleTabChangeWithEvent } = useTabTracking({
    sidebarTab: Players.title,
    tabs,
    customNavigate: (newValue) => {
      setTab(newValue as EPlayersState);
      navigate(getPlayersPath(basePath, newValue as EPlayersState));
    }
  });

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Players" />}
      handleTabChange={handleTabChangeWithEvent}
      activeTabVal={tab}
    />
  );
};
